import { DOCTORS_TAB } from "../../framework/tab/tabUtilsConstants";
import {
  medicineCategories,
  medicineScheduleTypes,
} from "../../utils/constant";

export const columnDefs = [
  {
    headerName: "Doctor Id",
    field: "doctorId",
    width: 150,
    hide: true,
  },
  {
    headerName: "Company Name",
    field: "company",
    width: 150,
    locked: true,
  },
  {
    headerName: "Doctor Name",
    field: "doctorName",
    width: 150,
    locked: true,
  },
  {
    headerName: "Doctor Address",
    field: "doctorAddress",
    width: 150,
    locked: true,
  },
  {
    headerName: "Doctor Hospital",
    field: "doctorHospital",
    width: 150,
    locked: true,
  },
  {
    headerName: "Doctor Phone",
    field: "doctorPhone",
    width: 150,
    locked: true,
  },
  {
    headerName: "Phone/Landline Number",
    field: "landlineNumber",
    width: 150,
  },
  {
    headerName: "Doctor Qualification",
    field: "qualification",
    width: 150,
    locked: true,
  },
  {
    headerName: "Profession",
    field: "professionName",
    width: 150,
    locked: true,
  },
  {
    headerName: "License Number",
    field: "licenceNo",
    width: 150,
    locked: true,
  },
  {
    headerName: "Speciality",
    field: "speciality",
    width: 150,
  },
  {
    headerName: "Doctor Type",
    field: "doctorType",
    width: 150,
  },
  {
    headerName: "Pin Code",
    field: "pincode",
    width: 150,
  },
  {
    headerName: "Remarks",
    field: "remarks",
    width: 150,
  },
];

export const columnDefsFunctions = {
  allowDiscount: {
    valueGetter: (params) => {
      return params.data.allowDiscount ? "true" : "false";
    },
  },
  isReturnable: {
    valueGetter: (params) => {
      return params.data.isReturnable ? "true" : "false";
    },
  },
  isLoose: {
    valueGetter: (params) => {
      return params.data.isLoose ? "true" : "false";
    },
  },
  rateItemwise: {
    valueGetter: (params) => {
      return params.data.rateItemwise ? "true" : "false";
    },
  },
  scheduledId: {
    valueGetter: (params) => {
      return medicineScheduleTypes.filter(
        (scheduleType) => scheduleType.id === params.data.scheduledId
      )[0]?.label;
    },
  },
  categoryId: {
    valueGetter: (params) => {
      return medicineCategories.filter(
        (g) => g.id === params.data.categoryId
      )[0]?.label;
    },
  },
  speciality: {
    valueGetter: (params) => {
      return params.data.specialityData?.name;
    },
  },
  doctorType: {
    valueGetter: (params) => {
     return params.data.doctorType?.toUpperCase();
    },
  },
};

export const transformPayload = (doctor) => {
  return {
    doctorName: doctor?.doctorName || "",
    doctorAddress: doctor?.doctorAddress || "",
    doctorPhone: doctor?.doctorPhone || "",
    doctorId: doctor?.doctorId || undefined,
    doctorHospital: doctor?.doctorHospital || "",
    licenceNo: doctor?.licenceNo || "",
    qualification: doctor?.qualification || "",
    registrationNo: doctor?.registrationNo || null,
    remarks: doctor?.remarks || "",
    specialityId: doctor?.specialityId || null,
    specialityName: doctor?.specialityName || "",
    landlineNumber: doctor?.landlineNumber || "",
    pincode: doctor?.pincode || "",
    professionId: doctor?.professionId || undefined,
    name: doctor?.name || null,
    doctorType: doctor?.doctorType?.id || null,
  };
};

export const initial_state_doctors = {
  type: DOCTORS_TAB,
  label: "Doctors",
  allowMultipleTabs: false,
};
